import api from "./api-manager";

const { REACT_APP_API_A39 } = process.env;

export default {
  async getAllAdsList() {
    const token = await sessionStorage.getItem("rmp_token");
    return api.post(
      `/v1/ads/list`,
      {},
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
  async changeConnectedAds(g_ads_id, fb_id) {
    console.log("changeConnectedAds", g_ads_id, fb_id);
    const token = await sessionStorage.getItem("rmp_token");
    return api.put(
      "/v1/ads/update",
      { g_ads_id, fb_id },
      {
        baseURL: REACT_APP_API_A39,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      },
    );
  },
};
